enum RelatedEntityType {
  Alert = 'Alert',
  DatasetRecord = 'DatasetRecord',
  DatasetScan = 'DatasetScan',
  Provider = 'Provider',
  User = 'User',
  UserRole = 'UserRole',
  Payer = 'Payer',
  PayerPlan = 'PayerPlan',
  Webhook = 'Webhook',
  BoardCertification = 'BoardCertification',
  BoardCertificationVerification = 'BoardCertificationVerification',
  License = 'License',
  LicenseVerification = 'LicenseVerification',
  DeaVerification = 'DeaVerification',
  Group = 'Group',
  Note = 'Note',
  Address = 'Address',
  Import = 'Import',
  VerificationRequest = 'VerificationRequest',
  Npi = 'Npi',
  CredentialingRequest = 'CredentialingRequest',
  Report = 'Report',
  ProfileMerge = 'ProfileMerge',
  Facility = 'Facility',
  FacilitySpecialty = 'FacilitySpecialty',
  ReferenceId = 'ReferenceId'
}

export default RelatedEntityType;

export const IgnoredRelatedEntityType = {
  DatasetRecord: 'DatasetRecord',
  User: 'User',
  UserRole: 'UserRole',
  Webhook: 'Webhook',
  BoardCertificationVerification: 'BoardCertificationVerification',
  LicenseVerification: 'LicenseVerification',
  Import: 'Import',
  VerificationRequest: 'VerificationRequest',
  Note: 'Note',
  Address: 'Address',
  Npi: 'NPI'
};
